/**
 * La forme de « Mes quêtes » pendant son premier chargement : quatre cartes de quête, une par
 * champion, dans la grille de la page.
 */
import React from "react"
import { View } from "react-native"

import { QuestCardSkeleton } from "../../organisms/QuestCard"
import { questsGridStyles } from "./questsGrid"

export function StudentQuestsSkeleton() {
    return (
        <View style={questsGridStyles.grid}>
            {[0, 1, 2, 3].map((index) => (
                <View key={index} style={questsGridStyles.cell}>
                    <QuestCardSkeleton />
                </View>
            ))}
        </View>
    )
}
